import React from 'react';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'clsx';

import { FlexRow } from 'ui-components/components/flex/row';
import { Text, TextType } from 'ui-components/components/text';

import { harmonizationMessages } from './messages';
import styles from './styles.module.css';

/** @type {Record<import('./harmonization-api').ConfidenceLevel, string>} */
const CONFIDENCE_CLASS_MAP = {
  High: 'confidenceHigh',
  Medium: 'confidenceMedium',
  Low: 'confidenceLow',
};

/** @type {Record<import('./harmonization-api').ConfidenceLevel, {id: string, defaultMessage: string, description: string}>} */
const CONFIDENCE_MESSAGE_MAP = {
  High: harmonizationMessages.confidenceHigh,
  Medium: harmonizationMessages.confidenceMedium,
  Low: harmonizationMessages.confidenceLow,
};

/** @type {import('./harmonization-api').ConfidenceLevel} */
const DEFAULT_CONFIDENCE = 'Low';

const handleKeyDown = (event, onClick) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onClick();
  }
};

/* TODO: Move chapter above reasoning and link out to wco with text search query param using chapter */

/**
 * @param {{
 *   code: string,
 *   confidence: import('./harmonization-api').ConfidenceLevel,
 *   reasoning: string,
 *   referenceChapter?: string,
 *   onClick: () => void,
 *   isSelected?: boolean
 * }} props
 * @returns {React.ReactElement}
 */
export const HarmonizationResultCard = ({ code, confidence, reasoning, referenceChapter, onClick, isSelected = false }) => {
  const confidenceLevel = confidence ?? DEFAULT_CONFIDENCE;
  const confidenceMessageDescriptor = CONFIDENCE_MESSAGE_MAP[confidenceLevel];
  const confidenceClassName = CONFIDENCE_CLASS_MAP[confidenceLevel];

  return (
    <div
      className={classnames(styles.resultCard, { [styles.resultCardSelected]: isSelected })}
      onClick={onClick}
      onKeyDown={(e) => handleKeyDown(e, onClick)}
      role='button' // oxlint-disable-line jsx-a11y/prefer-tag-over-role
      tabIndex={0}
    >
      {isSelected ? (
        <div className={styles.resultCardCheckmark}>
          <FontAwesomeIcon icon={faCheckCircle} />
        </div>
      ) : null}
      <FlexRow className={styles.resultCardHeader}>
        <span className={styles.codeBadge}>
          <Text textType={TextType.Label} value={code} />
        </span>
        <span className={classnames(styles.confidenceBadge, styles[confidenceClassName])}>
          <Text textType={TextType.Caption} value={confidenceMessageDescriptor} />
        </span>
      </FlexRow>

      <Text className={styles.reasoning} textType={TextType.Paragraph} value={reasoning} />

      {referenceChapter ? <Text className={styles.chapter} textType={TextType.Caption} value={referenceChapter} /> : null}
    </div>
  );
};
